import { useQueryWithUserId } from '@northladder/services';

import { CUSTOMER_SERVICE_API } from '../customerServiceClient';

/**
 * This is to track the deal details mutation keys in react query cache.
 */
export const GRADE_REVIEW_REQUEST_DETAILS_QUERY =
  'grade-review-request-details-key';

/**
 * This hook fetches the deal details using appraisal code as parameter.
 */
export const useGradeReviewRequestDetailsQuery = (id: string) => {
  const { data, isPending, isFetching, isError, error, refetch } =
    useQueryWithUserId({
      queryKey: [GRADE_REVIEW_REQUEST_DETAILS_QUERY, id],
      enabled: !!id,
      networkMode: 'always',
      retry: true,
      queryFn: () => CUSTOMER_SERVICE_API.fetchGradeReviewDetails(id),
    });

  return {
    data,
    error,
    isFetching,
    isPending,
    isError,
    refetch,
  };
};
